import React, { useEffect, useState } from "react";
import { auth } from "./Firebase";
import { onAuthStateChanged } from "firebase/auth";


export const AuthContext = React.createContext();

// Store authentication status
export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [pending, setPending] = useState(true);

    //Hook to watch for auth changes
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user)
            setPending(false)
        });
        
        return unsubscribe;
    }, []);

    //Firebase auth will take too long so we force it to wait until we have an auth context.
    //This will make the page take time to load, potentially bad for nonfunctional requirements if left unchecked.
    if(pending){
        return <>Loading...</>
    }


    return (
        //display whatever was passed in.
        <AuthContext.Provider value= {{ currentUser }}> {children} </AuthContext.Provider>
    );
};
